import { db } from "./firebase.js";

const getOnlyDocDataQuery = (col, filed, value) => {
  return new Promise((resolve) => {
    const docs = [];
    db.collection(col)
      .where(filed, "==", value)
      .get()
      .then((snapshot) => {
        snapshot.forEach((doc) => {
          docs.push({
            id: doc.id,
            data: doc.data(),
          });
        });
        if (docs.length == 1) {
          resolve({ ok: true, data: docs[0] });
        } else {
          resolve({ ok: false, data: docs.length });
        }
      });
  });
};

const getAllDocDataQuery = (col, filed, value) => {
  return new Promise((resolve) => {
    const docs = [];
    db.collection(col)
      .where(filed, "==", value)
      .get()
      .then((snapshot) => {
        snapshot.forEach((doc) => {
          docs.push({
            id: doc.id,
            data: doc.data(),
          });
        });
        resolve({ ok: true, data: docs });
      });
  });
};

const addDoc = (col, data) => {
  return new Promise((resolve) => {
    const docRef = db.collection(col).doc();
    docRef
      .set(data)
      .then(() => {
        resolve({ ok: true, data: docRef.id });
      })
      .catch(() => {
        resolve({ ok: false });
      });
  });
};

const setDoc = (col, doc, data) => {
  return new Promise((resolve) => {
    const docRef = db.collection(col).doc(doc);
    docRef
      .set(data)
      .then(() => {
        resolve({ ok: true });
      })
      .catch(() => {
        resolve({ ok: false });
      });
  });
};

const getDoc = (col, docId) => {
  return new Promise((resolve) => {
    const docRef = db.collection(col).doc(docId);
    docRef
      .get()
      .then((snapshot) => {
        const data = snapshot.data();
        if (data) {
          resolve({ ok: true, data: { id: docId, data: data } });
        } else {
          resolve({ ok: false });
        }
      })
      .catch(() => {
        resolve({ ok: false });
      });
  });
};

const getDocs = async (col, docIds) => {
  const p = docIds.map((item) => getDoc(col, item));
  return await Promise.all(p);
};

const deleteDoc = (col, docId) => {
  return new Promise((resolve) => {
    const docRef = db.collection(col).doc(docId);
    docRef
      .delete()
      .then(() => {
        resolve({ ok: true });
      })
      .catch(() => {
        resolve({ ok: false });
      });
  });
};

const updateDocById = (col, id, data) => {
  return new Promise((resolve) => {
    const docRef = db.collection(col).doc(id);
    docRef
      .update(data)
      .then(() => {
        resolve({ ok: true, data: docRef.id });
      })
      .catch(() => {
        resolve({ ok: false });
      });
  });
};

const addDocIfNotExist = (col, filed, value, data) => {
  return new Promise((resolve) => {
    const docs = [];
    db.collection(col)
      .where(filed, "==", value)
      .get()
      .then((snapshot) => {
        snapshot.forEach((doc) => {
          docs.push({
            id: doc.id,
            data: doc.data(),
          });
        });
        if (docs.length == 1) {
          resolve({ ok: true, data: docs[0] });
        } else if (docs.length == 0) {
          const docRef = db.collection(col).doc();
          docRef
            .set(data)
            .then(() => {
              resolve({ ok: true, data: { id: docRef.id, data: data } });
            })
            .catch(() => {
              resolve({ ok: false });
            });
        } else {
          resolve({ ok: false, data: docs.length });
        }
      });
  });
};

const updateByFiled = (col, filed, value, data) => {
  return new Promise((resolve) => {
    const docs = [];
    db.collection(col)
      .where(filed, "==", value)
      .get()
      .then((snapshot) => {
        snapshot.forEach((doc) => {
          docs.push({
            id: doc.id,
            data: doc.data(),
          });
        });
        if (docs.length == 1) {
          db.collection(col)
            .doc(docs[0].id)
            .update(data)
            .then(() => resolve({ ok: true }))
            .catch(() => resolve({ ok: false }));
        } else {
          resolve({ ok: false, data: docs.length });
        }
      });
  });
};

const getConsultantSlackToName = () => {
  return new Promise((resolve) => {
    const rv = {};
    db.collection("consultants")
      .get()
      .then((snapshot) => {
        snapshot.forEach((doc) => {
          const data = doc.data();
          if (data.slack_id) {
            rv[data.slack_id] = data.name ? data.name : data.slack_id;
          }
        });
        resolve(rv);
      });
  });
};

const getApplies = () => {
  return new Promise((resolve) => {
    const docs = [];
    db.collection("applies")
      .get()
      .then((snapshot) => {
        snapshot.forEach((doc) => {
          docs.push({
            id: doc.id,
            data: doc.data(),
          });
        });
        resolve({ ok: true, data: docs });
      });
  });
};

const fieldExist = (col, field, value) => {
  return new Promise((resolve) => {
    db.collection(col)
      .where(field, "==", value)
      .get()
      .then((snapshot) => {
        resolve(!snapshot.empty);
      });
  });
};

export {
  getOnlyDocDataQuery,
  getAllDocDataQuery,
  addDoc,
  updateDocById,
  addDocIfNotExist,
  updateByFiled,
  getConsultantSlackToName,
  getApplies,
  fieldExist,
  getDoc,
  setDoc,
  deleteDoc,
  getDocs,
};
